import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Button } from 'reactstrap';

import Alert from '~/components/Alert/Alert';
import Icon from '~/components/Icon/Icon';

const PacketaAlert: React.FC = () => {
  const { t } = useTranslation(['common']);

  return (
    <Alert
      type="primary"
      className="mb-3"
    >
      <Icon
        name="info"
        className="mr-2"
      />

      <p className="mb-0">
        <Trans i18nKey="common:PacketaBanner.message" />
      </p>

      <Button
        type="button"
        color="info"
        outline
        className="banner-btn"
        target="_blank"
        href="https://podpora.stiteknabalik.cz/article/156-nadchazejici-zmeny-stitku-zasilkovny"
      >
        {t('common:PacketaBanner.button')}
      </Button>
    </Alert>
  );
};

export default PacketaAlert;
